import { render, staticRenderFns } from "./AddMessage.vue?vue&type=template&id=23afe9c0&"
import script from "./AddMessage.vue?vue&type=script&lang=js&"
export * from "./AddMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports